module.exports = __webpack_public_path__ + "img/bg-1.e5e73900.png";